export const FETCH_GEOIP_BEGIN = 'FETCH_GEOIP_BEGIN';
export const FETCH_GEOIP_SUCCESS = 'FETCH_GEOIP_SUCCESS';
export const FETCH_GEOIP_FAILURE = 'FETCH_GEOIP_FAILURE';

export const SET_LOCATION = 'SET_LOCATION';
export const LOAD_FAVORITES = 'LOAD_FAVORITES';

export const LOCATION_CONFIRM = 'LOCATION_CONFIRM';
